$(function (){

     // simple steps slider
     var simpleStepsSlider = {   
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true, 
        dots: true,
        infinite: false,
        autoplaySpeed: 5000,
        autoplay: false,
        mobileFirst: true,
        prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55102 1.34692L1.38775 9.51019L9.55102 17.6735" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
        nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44897 1.34692L9.61224 9.51019L1.44897 17.6735" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
        responsive: [
        {
            breakpoint: 992,
            settings: 'unslick'
        },
        ]
    }
    var win = $(window);
    var slider = $(".simple-steps__slider");

    win.on("load resize", function () {  
      if (win.width() < 992) {
        slider.not(".slick-initialized").slick(simpleStepsSlider);
      } else if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
    });
    // end simple steps slider

    // our ranges slider
    if($('.our-ranges__slider').length > 0){
      $('.our-ranges__slider').slick({
          pauseOnHover: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed:5000,
          focusOnSelect: true,
          dots: true,
          appendDots: $('.slider-dots-box'),
          dotsClass: 'slider-dots',
          arrow: true,
          centerMode: true,
          prevArrow: $('.cutsom-arrow.arrow-prev'),
          nextArrow: $('.cutsom-arrow.arrow-next'),
          responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 641,
                settings: {
                  slidesToShow: 1,
                }
              }
          ]
      });
    }
    // end our ranges slider

     // marquee slider
     if($('.marquee-slider__wraper').length > 0){
      $('.marquee-slider__wraper').slick({
          pauseOnHover: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed:5000,
          focusOnSelect: true,
          dots: false,
          arrow: false,
          infinite: true,
          centerMode: true,
      });
    }
    // end marquee slider


    // our testimonial
    if($('.testimonial__slider').length > 0){
      $('.testimonial__slider').slick({
          pauseOnHover: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed:5000,
          focusOnSelect: true,
          dots: false,
          arrow: true,
          centerMode: true,
          prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55102 1.34692L1.38775 9.51019L9.55102 17.6735" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
          nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44897 1.34692L9.61224 9.51019L1.44897 17.6735" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                centerMode: false,
              }
            }
        ]
      });
    }
    // end testimonial

    // faq accordion
    $('.accordion > li:first-child').addClass('active');
    $('.accordion > li.active .ans').slideDown();

    $('.accordion h6').click(function() {
        var dropDown = $(this).closest('li').find('.ans');

        $(this).closest('.accordion').find('.ans').not(dropDown).slideUp();

        if ($(this).parent("li").hasClass('active')) {
            $(this).parent("li").removeClass('active');
        } else {
            $(this).closest('.accordion').find('li.active').removeClass('active');
            $(this).parent("li").addClass('active');
        }
        dropDown.stop(false, true).slideToggle();
    });
    // end faq accordion

    // announcement slider
    var announcementSlider = {   
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true, 
        dots: false,
        infinite: false,
        autoplaySpeed: 5000,
        autoplay: true,
        mobileFirst: true,
        prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg fill=none height=14 viewBox="0 0 14 14"width=14 xmlns=http://www.w3.org/2000/svg><path d="M8.1667 10.5L8.9892 9.6775L6.31753 7L8.9892 4.3225L8.1667 3.5L4.6667 7L8.1667 10.5Z"fill=#404041 fill-opacity=0.3 /></svg></button>',
        nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg fill=none height=14 viewBox="0 0 14 14"width=14 xmlns=http://www.w3.org/2000/svg><path d="M5.8333 3.5L5.0108 4.3225L7.68247 7L5.0108 9.6775L5.8333 10.5L9.3333 7L5.8333 3.5Z"fill=#404041 fill-opacity=0.3 /></svg></button>',
        responsive: [
          {
              breakpoint: 992,
              settings: 'unslick'
          },
        ]
    }
    var winAnnouncement = $(window);
    var sliderAnnouncement = $(".announcement__slider");

    winAnnouncement.on("load resize", function () {  
      if (winAnnouncement.width() < 992) {
        sliderAnnouncement.not(".slick-initialized").slick(announcementSlider);
      } else if (sliderAnnouncement.hasClass("slick-initialized")) {
        sliderAnnouncement.slick("unslick");
      }
    });
    // end announcement slider

    // hamburger menu show
    $(".hamburg-icon").on("click", function (e) {
      e.preventDefault();
      $(this).parent().find('.mobile-menu').toggleClass('mobile-menu--show');
      $("body").toggleClass("menu-open");
      $(".hamburg-close").toggleClass("hamburg-close--show");
    });
    $(".hamburg-close").on("click", function (e) {
      e.preventDefault();
      $(this).removeClass("hamburg-close--show");
      $('.mobile-menu').removeClass('mobile-menu--show');
      $("body").removeClass("menu-open");
    });
    // end hamburger menu show

    // collection step active
    $(".collection__step ul li a").on("click", function () {
        // let getId =  $(this).attr("href");
        $(".collection__step ul li").removeClass("active");
        $(".collection__wraper .tab-content .tab-pane").removeClass("active");
        $(".collection__wraper .tab-content .tab-pane").css("display", "none");

        $(this).parent().addClass("active");
        $(".collection__wraper .tab-content").addClass("active");
    });
    // end collection step active

    // select 2
    $("#single-size").select2({
      placeholder: "Select size",
      allowClear: true
    });
    $("#single-model").select2({
      placeholder: "Select Size",
      allowClear: true
    });

    let optionName1 = $('#single-size-cart').attr('data-option-name');
    let optionName2 = $('#single-modal-cart').attr('data-option-name');
     $("#single-size-cart").select2({
      placeholder: 'Select ' + optionName1,
      allowClear: true
    });
    $("#single-modal-cart").select2({
      placeholder: 'Select ' + optionName2,
      allowClear: true
    });
    // end select 2
    
    // size select dropdwon
    $(".size-select").on("click", function () {
        $(".btn-custom").removeClass("btn-custom--active");
        $(this).addClass("btn-custom--active");
        $("#dropdwon-size").removeClass("d-none");
        $("#dropdwon-model").addClass("d-none");
    });
    // end size select dropdwon

    // model select dropdwon
    $(".model-select").on("click", function () {
      $(".btn-custom").removeClass("btn-custom--active");
      $(this).addClass("btn-custom--active");
      $("#dropdwon-model").removeClass("d-none");
      $("#dropdwon-size").addClass("d-none");
    });
    // model select dropdwon

    // collection process step 
    var currentStep = 1;
    var updateProgressBar;

    function displayStep(stepNumber) {
      if (stepNumber >= 1 && stepNumber <= 2) {
        $(".step-" + currentStep).hide();
        $(".step-" + stepNumber).show();
        currentStep = stepNumber;

        updateProgressBar();
      }
      if(stepNumber == 3){
        currentStep = stepNumber;
        updateProgressBar();
      }

    }
    $('.collection__form').find('.step').slice(1).hide();
    updateProgressBar = function() {
      var progressPercentage = ((currentStep - 1) / 2) * 100;

      if(progressPercentage == "100"){
        $(".progress-bar").css("width",  "calc("+progressPercentage+"% - 100px)");
      }else{
        $(".progress-bar").css("width",  "calc("+progressPercentage+"% - 50px)");
      }
    }

    $(".collection__step ul li").on("click", function () {
        $(".collection__step ul li").removeClass("active");
        let getId =  $(this).attr("data-click");
        $(this).addClass("active");
        $(this).prev("li").addClass("process-done");

        // if($(this).hasClass("process-done") == true){
        //   $(this).next("li").css("pointer-events", "painted");
        // }

        if(getId == 1){
          $(".collection__step ul li:nth-child(2)").removeClass("process-done");
          $('.js_radio_button').prop('checked',false);
        } 

        if(getId == 2){
          $(".product-list").addClass("d-none");
        } 

        if(getId == 3){
          $(".product-list").removeClass("d-none");
        } 

        metchProductTitle();
        displayStep(getId);
    });

    // $("body").on("click", ".collection__step ul li", function () {
    //   $(".collection__step ul li:first-child").trigger("click");
    //   $(this).removeClass("process-done");
    // });

    $("body").on("change", ".tab-pane ul.radio-buttons li input", function () {
      $(".collection__step ul li:nth-child(2)").trigger("click");
    });

    $('#single-size').on('select2:select', function (e) {
        $(".collection__step ul li:nth-child(3)").trigger("click");
    });

    $('#single-model').on('select2:select', function (e) {
      $(".collection__step ul li:nth-child(3)").trigger("click");
    });
    // end collection process step

    // metch height
    function metchProductTitle(){
      $('.product-list__desc h5').matchHeight({
          byRow: 0,
      });
    }
    metchProductTitle();
    // end metch height

    
    // collection page in on select size/model then redirect to product list 
    function modelSizeSelection() {
      if ($(window).width() <= 991 ) {
        if($(".box-desc").hasClass("is-sticky") == false){
            $('html, body').stop(true).animate({ scrollTop: $('.product-list').offset().top - 330}, 180);
        }else{
            $('html, body').stop(true).animate({ scrollTop: $('.product-list').offset().top - 160}, 180);
        }
      }else{
        $('html, body').stop(true).animate({ scrollTop: $('.product-list').offset().top - 20}, 180);
      }
    }
    $('#single-model, #single-size').on('select2:select', function () {
      modelSizeSelection();
    });
    // end collection page in on select size/model then redirect to product list   

    // special-offer validation
    function specialOfferValidation() {
      $("#product_form_7502859534515").validate({
        rules: {
          specialOfferSelect_1: "required",
          specialOfferSelect_2: "required",
          specialOfferColor: "required",
        },
        messages: {
          specialOfferSelect_1: "Please select size",
          specialOfferSelect_2: "Please select model",
          specialOfferColor: "Please select color",
        },
      });
    }

    $("#product_form_7502859534515 .product-count .btn-custom").on('click', function(e) {
      e.preventDefault();
      specialOfferValidation();
      if($("#product_form_7502859534515").valid() == true){
          $("#product_form_7502859534515").submit();
          return true;
      }else{
        return false;
      }
    });
    // end special-offer validation

    // special-offer select2 placeholder color
    $("#product_form_7502859534515 .select-color #color").select2({
      placeholder: "Select Color",
      allowClear: true
    });
    // end special-offer select2 placeholder color
   
    // hero slider
    var slideWrapper = $(".hero__slider");

    function playPauseVideo(slick, control){
      var currentSlide, slideType, startTime, video;
    
      currentSlide = slick.find(".slick-current");
      slideType = currentSlide.attr("class").split(" ")[1];
      startTime = currentSlide.data("video-start");
    
      if (slideType === "hero-video") {
        video = currentSlide.children("video").get(0);
        if (video != null) {
          if (control === "play"){
            video.muted = true;
            video.loop = true;
            video.play();
          } else {
            video.pause();
          }
        }
      }
    }

    slideWrapper.on('init', function(event, slick){
      var autoplayVideo = $(".hero__item.hero-video.slick-current").find('video').get(0);
      if (autoplayVideo != null) {
        autoplayVideo.muted = true;
        autoplayVideo.loop = true;
          autoplayVideo.play();
      }
    });

    slideWrapper.on("beforeChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"pause");
    });

    slideWrapper.on("afterChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"play");
    });

    slideWrapper.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed:4000,
      lazyLoad:"progressive",
      speed:600,
      arrows:true,
      dots:false,
      autoplay: false,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55102 1.34692L1.38775 9.51019L9.55102 17.6735" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
      nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44897 1.34692L9.61224 9.51019L1.44897 17.6735" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
    });
    // end hero slider

    // for customization load
    $(document).on('shopify:section:load', function(){
      if($('.marquee-slider__wraper').length > 0 && $('.marquee-slider__wraper').hasClass('slick-initialized') == false ) {
        $('.marquee-slider__wraper').slick({
            pauseOnHover: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed:5000,
            focusOnSelect: true,
            dots: false,
            arrow: false,
            infinite: true,
            centerMode: true,
        });
      }
      if($('.our-ranges__slider').length > 0 && $('.our-ranges__slider').hasClass('slick-initialized') == false ) {
          $('.our-ranges__slider').slick({
            pauseOnHover: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed:5000,
            focusOnSelect: true,
            dots: true,
            appendDots: $('.slider-dots-box'),
            dotsClass: 'slider-dots',
            arrow: true,
            centerMode: true,
            prevArrow: $('.cutsom-arrow.arrow-prev'),
            nextArrow: $('.cutsom-arrow.arrow-next'),
            responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 641,
                  settings: {
                    slidesToShow: 1,
                  }
                }
            ]
        });
      }
  });
  // end for customization load

  // collections page - load more button click after load other product list
  // $(".product-list .js-load-more-btn").on('click', function (e) {
  //     e.preventDefault();
  //     $(".product-list__col:hidden").slice(0, 6).slideDown("slow");
  //     if ($(".product-list__col:hidden").length == 0) {
  //        $(".product-list .js-load-more-btn").hide();
  //     } else {
  //         $('html,body').animate({
  //             scrollTop: $(this).offset().top - 1250
  //         }, 1200);
  //     }
  // });
  // end collections page - load more button click after load other product list

  // collection page in the select product category then redirect to the second step
  function productCategorySelect() {
    let getWindowWidth = $(window).width();
      if (getWindowWidth <= 991 ) {
          $('html, body').stop(true).animate({ scrollTop: $('.collection__step').offset().top - 50}, 180);
      }
      else{
        $('html, body').stop(true).animate({ scrollTop: $('.collection__step').offset().top - 100}, 180);
      }
  }  
  $('.js_radio_button').on('click', function () {
    productCategorySelect();
  });
  // end collection page in the select product category then redirect to the second step

  $(document).on("click", ".ryviu-collection", function ()  {
      redirectToSection("product-detail-testimonial");
  });

});

window.sticky = new Sticky(".box-desc");

function redirectToSection(sectionId) {
  var section = document.getElementById(sectionId);
  section.scrollIntoView({
      behavior: 'smooth',
      block: 'start', 
      inline: 'nearest'
  });
}